import React, { useEffect, useRef } from 'react'
import { Container, Grid, Form } from './styled'
import { config } from './config'

const win: any = window

interface Props {
  clientToken: string
  publicKeyBase64: string
  onLoad: (paymentForm: PaymentForm) => void
}

export const PayeezyCreditCardForm = ({
  clientToken,
  publicKeyBase64,
  onLoad
}: Props) => {
  const onLoadCallback = useRef(onLoad)

  useEffect(() => {
    win.firstdata?.createPaymentForm?.(config, {
      preFlowHook: (preFlowHook: PreFlowHook) => {
        preFlowHook({ clientToken, publicKeyBase64 })
      }
    }, onLoadCallback.current)
  }, [clientToken, publicKeyBase64, onLoadCallback])

  return (
    <Container>
      <Form id='form'>
        <div>
          <label className='control-label'>Card Number</label>
          <div
            className='form-controls payment-fields disabled empty'
            id='cc-card'
          />
        </div>

        <div>
          <label className='control-label'>Card Holder Name</label>
          <div className='form-controls payment-fields disabled' id='cc-name' />
        </div>
        <Grid>
          <div className='col1'>
            <label className='control-label'>Exp Date</label>
            <div
              className='form-controls payment-fields disabled empty'
              id='cc-exp'
            />
          </div>

          <div className='col2'>
            <label className='control-label'>CVV</label>
            <div
              className='form-controls payment-fields disabled empty'
              id='cc-cvv'
            />
          </div>
        </Grid>
      </Form>
    </Container>
  )
}

type PreFlowHook = (params: { clientToken: string, publicKeyBase64: string }) => void
type PaymentFormOnSubmit = (success: (token: string) => void, error?: (error: Error) => void) => void
type PaymentFormReset = (success: (token: string) => void, error?: (error: Error) => void) => void

// https://docs.paymentjs.firstdata.com/
export interface PaymentForm {
  authenticate: (t: any, e: any) => void
  createFields: (t: any, e: any) => void
  createFrame: (t: any) => void
  createFrames: () => void
  destroyFields: (t: any, e: any) => void
  getFieldElement: (t: any) => void
  getFieldElementUtils: (t: any) => void
  getFrameElement: (t: any) => void
  getState: (t: any) => void
  injectConfig: (t: any) => void
  isSupported: () => void
  isValid: () => void
  on: (t: any, e: any) => void
  onClickLabel: () => void
  onFieldBlur: (t: any, e: any, n: any) => void
  onFieldCardType: (t: any, e: any, n: any) => void
  onFieldChange: (t: any, e: any, n: any) => void
  onFieldFocus: (t: any, e: any, n: any) => void
  onSubmit: PaymentFormOnSubmit
  reset: PaymentFormReset
  setFieldFocus: (t: any, e: any, n: any) => void
  submit: (auth: any, resolve: any, reject: any) => void
  toggleClasses: () => void
  tokenize: (t: any) => void
  validate: (t: any, e: any) => void
  validityState: () => void
  waitUntilAllFramesLoaded: (t: any, e: any) => void
  writeLog: (t: any, e: any) => void
}
